// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Clock = createIcon(
  <path
    clipRule="evenodd"
    d="M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5ZM20.1998 12.4998C20.1998 17.0285 16.5285 20.6998 11.9998 20.6998C7.47107 20.6998 3.7998 17.0285 3.7998 12.4998C3.7998 7.97107 7.47107 4.2998 11.9998 4.2998C16.5285 4.2998 20.1998 7.97107 20.1998 12.4998ZM12.9001 9.08896C12.9001 8.59191 12.4972 8.18896 12.0001 8.18896C11.503 8.18896 11.1001 8.59191 11.1001 9.08896V12.9812C11.1001 13.2199 11.1949 13.4488 11.3637 13.6176L14.2939 16.5479C14.6453 16.8994 15.2152 16.8994 15.5666 16.5479C15.9181 16.1965 15.9181 15.6266 15.5667 15.2751L12.9001 12.6084V9.08896Z"
    fillRule="evenodd"
  />,
);
